import CrossStreet from "@components/Fields/CrossStreet";
import Directions from "@components/Fields/Directions";
import { useFormContext } from "@hudson/ui/components/ReactHookForm";
import useContent from "@lib/use_content";
import Location from "./Location";

interface LocationSectionProps {
  method: "add" | "edit";
  submitting: boolean;
}

export default function LocationSection({ method, submitting }: LocationSectionProps) {
  const { data, loading } = useContent(["beCrossStreetLabel", "bePickupDirectionsLabel"]);
  const formMethods = useFormContext();

  const enteredLocation: be.Location = formMethods.watch("location");
  const showCrossStreet = data?.content.beCrossStreetLabel && enteredLocation?.showCrossStreet;
  const showDirections =
    data?.content.bePickupDirectionsLabel && !enteredLocation?.transportationHub;

  return (
    <div>
      <Location className="max-w-[500px]" submitting={submitting} focusOnMount={method == "add"} />

      {(showCrossStreet || showDirections) && (
        <div className="grid grid-cols-1 mt-8 gap-y-8 sm:gap-x-4 max-w-80">
          {showCrossStreet && (
            <CrossStreet
              fieldName={`location.crossStreet`}
              label={data?.content.beCrossStreetLabel || ""}
            />
          )}

          {showDirections && (
            <Directions
              fieldName={`location.directions`}
              label={data?.content.bePickupDirectionsLabel || ""}
            />
          )}
        </div>
      )}
    </div>
  );
}
